export const HEADER_VISIBLE = 'navigation:header-visible'
export const SET_ACTIVE_MENU_DESKTOP = 'navigation:set-active-menu-desktop'
export const TOGGLE_MOBILE = 'navigation:toggle-mobile'
export const MENU_OPEN = 'navigation:menu-open'
export const MENU_CLOSE = 'navigation:menu-close'
export const ACCOUNT_OPEN = 'navigation:account-open'
export const ACCOUNT_CLOSE = 'navigation:account-close'
export const SUBMENU_OPEN = 'navigation:submenu-open'
export const SUBMENU_CLOSE = 'navigation:submenu-close'

export const EVENT_MAP = {
  menu: {
    open: MENU_OPEN,
    close: MENU_CLOSE,
  },
  submenu: {
    open: SUBMENU_OPEN,
    close: SUBMENU_CLOSE,
  },
  account: {
    open: ACCOUNT_OPEN,
    close: ACCOUNT_CLOSE,
  },
}
